

import { Card, CardContent, LinearProgress, Grid, Box, Button, Link, makeStyles, Paper, Typography, FormControlLabel, Select, MenuItem, TextField, Checkbox, NativeSelect, OutlinedInput, FormControl, InputLabel, List, ListItem, Table, TableRow, TableCell, Alert, AlertTitle, Dialog, DialogContent, Tooltip, Collapse, Divider, CircularProgress } from '@mui/material';
import React, { Component, useEffect, useState } from 'react'
import { Field, Form, Formik, FormikProvider, useFormik } from 'formik';

import * as Yup from "yup";
//import PostService from "../../../services/post.service";
import { Navigate, Link as routerLink } from "react-router-dom";
import { DeviceTextAdornmentReadOnlyField, BatchTextAdornmentReadOnlyField, UserTextAdornmentReadOnlyField, OrganisationTextAdornmentReadOnlyField, FormVisualResultsField, ImageField, FormVisualResultsBulkReviewField, StripImageField } from '../fields/resultDetailFields';
import { ResultDetailEditField, NotesField, ResultDetailTableField, NotesEditField, InterpretationSelectField, InterpretationReviewSelectField, NotesBulkReviewEditField } from '../fields/fields';

import api from '../../../redux/features/auth/axiosAuthHelper';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import assets from '../../../assets'
import colorConfigs from '../../../configs/colorConfigs';
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import fontConfigs from '../../../configs/fontConfigs';
import ResultDetailGraph from '../graphs/ResultDetailGraph';
import RareButton from '../buttons/RareButton';
import ResultClassLabel from '../buttons/resultClassLabel';
import { interpretationColours, interpretationLabels, InterpretationOption } from '../CustomHooks';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ResultDetailTable from '../tables/ResultDetailTable';
import { MaterialReactTable, MRT_Row, type MRT_ColumnDef, type MRT_SortingState } from 'material-react-table';
import CheckIcon from '@mui/icons-material/Check';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

interface ResultDetailProps {
    result_id: any;
    popup: any;
    handleBackButton: () => void;
    handleUpdatedButton: () => void;

}

interface LineData {
    score: number | string;
    peak_position: number | string;
    tc_ratio: number;
}


const ResultDetailCard: React.FC<ResultDetailProps> = ({ handleBackButton, handleUpdatedButton, popup, result_id }) => {
    const [result, setResult] = useState<any>(null)
    const [user, setUser] = useState<any>("")
    const authData = useSelector((state: RootState) => state.auth);
    const [graphData, setGraphData] = useState<any>({
        test_lines: [],
        cscore: '',
        cpeak: '',
        profile: [''],
        baseline: [''],
        c_color: '',
        baseline_color: '',
        profile_color: '',
        profiles: [],
        baselines: [],
        meanProfileVisible: false,
    })
    const [testImage, setTestImage] = useState<any>()
    const [stripImages, setStripImages] = useState<any[]>([])
    const [lines, setLines] = useState<any[]>([])
    const [errors, setErrors] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedStrip, setSelectedStrip] = useState({
        baseline: [],
        c_line: {
            score: null,
            peak_position: null,
            area: null
        },
        lines: [
            { t_color: '', area: null }
        ],
        c_color: '',
        profile_color: '',
        baseline_color: '',
        main_image: "",
        mean_profile: [],
    });
    const validationSchema = () => {
        return Yup.object().shape({
        });
    }

    const fetchResult = async () => {
        try {
            const url = `results/${result_id}`

            const response = await api.get(url, {
                headers: {
                    'Authorization': `Bearer ${authData.access}`
                }
            });
            setResult(response.data);
            console.log("result", response.data)

            try {
                const url = `users/${response?.data?.user_id}`

                const res = await api.get(url, {
                    headers: {
                        'Authorization': `Bearer ${authData.access}`
                    }
                });
                setUser(res.data);
                console.log("user", res.data)

            } catch (error) {
                console.log(error)
                console.log(`Cannot find User with id ${result.user_id}`)
            }

        } catch (error) {
            console.error('Error fetching result', error);
            setErrors(`No Result found with ID ${result_id}`)
            setTimeout(() => {
                handleBackButton()
            }, 4000);
        }
    };

    useEffect(() => {
        fetchResult()
    }, [result_id])



    const formik = useFormik({
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: false,
        initialValues: {
            app_build: '',
            app_version: '',
            device_model: '',
            device_uuid: '',
            full_image: '',
            id: '',
            latitude: '',
            longitude: '',
            lot_number: '',
            batch_id: '',
            notes: '',
            organisation_id: '',
            organisation_name: '',
            os_version: '',
            sample_id: '',
            sample_type: '',

            strip_image_paths: [],
            // Test lines
            baseline: '',
            cline_score: '',
            cline_peak_position: '',
            // Lines
            lines: [],
            tline_1_score: '',
            tline_1_peak_position: '',
            tline_1_ratio: '',
            tline_2_score: '',
            tline_2_peak_position: '',
            tline_2_ratio: '',
            profile: '',

            test_type: '',
            timestamp: '',
            user_id: '',

            type: '',
            aborted_reason: '',
            app_interpretation: '',
            final_result_interpretation: '',

            // User Data
            result_user_id: '',
            user_first_name: '',
            user_last_name: '',
            user_email: '',
            user_is_active: '',
            user_organisation_id: '',
            user_organisation_name: '',
            user_user_type: '',

            // Visual result
            visual_result: false,
            visual_interpretation: '',
            visual_result_notes: '',
            is_reviewed: false,
            reviewer_id: '',
            reviewer_notes: '',
            reviewer_organisation_id: '',
            reviewed_timestamp: '',
            reviewer_agrees: '',
            reviewer_interpretation: '',
            initial_reviewer_interpretation: '',
            initial_visual_interpretation: '',



        },
        validationSchema,
        onSubmit: async (values) => {
            setLoading(true)

            const data = {
                ...(values.reviewer_notes && { reviewer_notes: values.reviewer_notes }),
                ...(values.reviewer_interpretation && { reviewer_interpretation: values.reviewer_interpretation })
            };

            const url = `results/${result.id}/review-visual-result`
            const method = 'patch'

            try {
                console.log("data", data)
                await api({
                    method,
                    url,
                    data,
                    headers: {
                        'Authorization': `Bearer ${authData.access}`,
                    },
                });
                setErrors(null);
                console.log("Result successfully reviewed")
                handleUpdatedButton() // reset states and close popup
                fetchResult()
                closeReview()

            } catch (error: any) {
                if (error?.response?.status === 400) {
                    const firstErrorItem = Object.keys(error.response.data)[0];
                    setErrors(`${firstErrorItem}: ${error.response.data[firstErrorItem]}`);
                } else if (error?.response?.status === 403) {
                    const firstErrorItem = Object.keys(error.response.data)[0];
                    setErrors(`${error.response.data[firstErrorItem]}`);
                } else {
                    const errorText = `Unknown error updating result`;
                    setErrors(errorText);
                    console.error(errorText, error);
                }
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } finally {
                setLoading(false)
            }
        },
    });

    useEffect(() => {
        if (result) {
            console.log("Result Data", result)

            formik.setFieldValue('type', result.type);

            // if aborted then ....
            const abortedResult = result.type === "ABORTED"

            setTestImage(result.full_image_path || '')
            // setTestImage("https://pub.mdpi-res.com/biosensors/biosensors-11-00211/article_deploy/html/images/biosensors-11-00211-g001.png?1627912606")
            // setTestImage("https://ddtd.staging.novarumcloud.com/backend/media/23-01-2025_16-33-03_image_phoenix.png")

            // Setting strip_image_paths as an array to dynamically render these
            formik.setFieldValue('strip_image_paths', result.strip_image_paths || ['']);
            if (result.strip_image_paths) {
                setStripImages(result.strip_image_paths);
                // setStripImages(["https://ddtd.staging.novarumcloud.com/backend/media/23-01-2025_16-33-03_image_phoenix.png", "https://ddtd.staging.novarumcloud.com/backend/media/23-01-2025_16-33-03_image_phoenix.png"]);
            }


            const dynamicProfiles: any[] = [];
            const dynamicBaselines: any[] = [];

            if (!abortedResult && result.test_strips.length > 0) {

                dynamicProfiles.push({ data: result.test_strips[0].profile, color: colorConfigs.result.meanProfile, name: "Mean Profile" });
                dynamicBaselines.push({ data: result.test_strips[0].baseline, color: colorConfigs.result.meanBaseline, name: "Mean Baseline" });
                const dynamicTestLines = result.test_strips[0].lines.map((line: any) => {
                    line["t_color"] = colorConfigs.tables.headBg
                    return line
                })
                console.log("SEAN", result.test_strips[0])
                setSelectedStrip(result.test_strips[0])
                setGraphData({
                    test_lines: dynamicTestLines,
                    cscore: result.test_strips[0].c_line.score || 0,
                    cpeak: result.test_strips[0].c_line.peak_position || 0,
                    c_color: colorConfigs.buttons.active,
                    profile: result.test_strips[0].profile,
                    baseline: result.test_strips[0].baseline,
                    baseline_color: colorConfigs.result.meanBaseline,
                    profile_color: colorConfigs.result.meanProfile,
                    profiles: dynamicProfiles, // Initialize as empty
                    baselines: dynamicBaselines, // Initialize as empty
                    meanProfileVisible: true
                });
            }

            console.log("GraphData", graphData)

            formik.setFieldValue('batch_id', result.batch_id);
            formik.setFieldValue('app_build', result.app_build);
            formik.setFieldValue('app_version', result.app_version);
            formik.setFieldValue('device_model', result.device_model);
            formik.setFieldValue('device_uuid', result.device_uuid);
            formik.setFieldValue('full_image', result.full_image);
            formik.setFieldValue('id', result.id);
            formik.setFieldValue('latitude', result.latitude);
            formik.setFieldValue('longitude', result.longitude);
            formik.setFieldValue('lot_number', result.lot_number);
            formik.setFieldValue('notes', result.notes);
            formik.setFieldValue('organisation_id', result.organisation_id);
            formik.setFieldValue('os_version', result.os_version);
            formik.setFieldValue('sample_id', result.sample_id);
            formik.setFieldValue('sample_type', result.sample_type);
            formik.setFieldValue('test_type', result.test_type)
            formik.setFieldValue('timestamp', dayjs(result.timestamp).format('YYYY-MM-DD HH:mm:ss'));
            formik.setFieldValue('user_id', result.user_id)
            formik.setFieldValue('uuid', result.uuid)
            formik.setFieldValue('visual_result', result.visual_result)
            formik.setFieldValue('aborted_reason', result.aborted_reason)
            formik.setFieldValue('app_interpretation', result.app_interpretation)
            // formik.setFieldValue( // Borderline is now BORDERLINE
            //     'app_interpretation',
            //     interpretationLabels[result.app_interpretation as keyof typeof interpretationLabels] ||
            //     result.app_interpretation
            // );
            formik.setFieldValue('final_result_interpretation', result.final_result_interpretation)
            // formik.setFieldValue( // Borderline is now BORDERLINE
            //     'final_result_interpretation',
            //     interpretationLabels[result.final_result_interpretation as keyof typeof interpretationLabels] ||
            //     result.final_result_interpretation
            // );
            formik.setFieldValue('orgainsation_id', result.orgainsation_id)
            formik.setFieldValue('organisation_name', result.organisation_name)

            if (result.visual_result) {
                formik.setFieldValue('initial_visual_interpretation', result.visual_result.visual_interpretation)
                // formik.setFieldValue(// Borderline is now BORDERLINE
                //     'visual_interpretation',
                //     interpretationLabels[result.visual_result?.visual_interpretation as keyof typeof interpretationLabels] ||
                //     result.visual_result?.visual_interpretation
                // );
                formik.setFieldValue('visual_result_notes', result.visual_result.notes)
                formik.setFieldValue('is_reviewed', result.visual_result.is_reviewed)
                formik.setFieldValue('reviewer_id', result.visual_result.reviewer_id)
                formik.setFieldValue('initial_reviewer_interpretation', result.visual_result.reviewer_interpretation || '')
                // formik.setFieldValue( // Borderline is now BORDERLINE
                //     'reviewer_interpretation',
                //     interpretationLabels[result.visual_result?.reviewer_interpretation as keyof typeof interpretationLabels] ||
                //     result.visual_result?.reviewer_interpretation || ''
                // );
                formik.setFieldValue('reviewer_notes', result.visual_result.reviewer_notes)
                formik.setFieldValue('reviewer_organisation_id', result.visual_result.reviewer_organisation_id)
                formik.setFieldValue('reviewed_timestamp', dayjs(result.visual_result.reviewed_timestamp).format('YYYY-MM-DD HH:mm:ss'))
                if (result.visual_result.reviewer_interpretation) {
                    formik.setFieldValue('reviewer_agrees', "Change")
                } else {
                    formik.setFieldValue('reviewer_agrees', "")
                }

            }
            if (user) {
                console.log("User", user)
                formik.setFieldValue('result_user_id', user.id);
                formik.setFieldValue('user_first_name', user.first_name);
                formik.setFieldValue('user_last_name', user.last_name);
                formik.setFieldValue('user_email', user.email);
                formik.setFieldValue('user_is_active', user.is_active);
                formik.setFieldValue('user_organisation_id', user.organisation);
                formik.setFieldValue('user_organisation_name', user.organisation_name);
                formik.setFieldValue('user_user_type', user.user_type);
            }
        }
    }, [user, result]);

    // Clear reviewer_interpretation if reviewer agrees
    useEffect(() => {
        if (formik.values.reviewer_agrees === "Agree") {
            formik.setFieldValue('reviewer_interpretation', formik.values.final_result_interpretation);
        } else if (formik.values.reviewer_agrees === "Change") {
            if (formik.values.is_reviewed) {
                formik.setFieldValue('reviewer_interpretation', '');
            } else {
                formik.setFieldValue('reviewer_interpretation', formik.values.visual_interpretation);
            }
        } else {
            formik.setFieldValue('reviewer_interpretation', formik.values.initial_reviewer_interpretation);
        }
    }, [formik.values.reviewer_agrees, formik.values.is_reviewed, formik.values.initial_reviewer_interpretation])

    const [selectedImage, setSelectedImage] = useState<any>("")
    const [openImagePopup, setOpenImagePopup] = useState<any>(false)
    const [reviewingInterpretation, setReviewingInterpretation] = useState<any>(false)
    const [viewingVisualResult, setViewingVisualResult] = useState<any>(false)

    const handleImageOpen = (image: any) => {
        setSelectedImage(image); // Set the selected strip image source
        setOpenImagePopup(true);
    };

    const handleImageClose = () => {
        setOpenImagePopup(false);
    };

    const openReview = () => {
        setReviewingInterpretation(true);
    };

    const closeReview = () => {
        setReviewingInterpretation(false);
    };

    const toggleViewVisualResult = () => {
        setViewingVisualResult(!viewingVisualResult);
    };


    // Define your columns for the test/ control lines table
    const detailColumns: MRT_ColumnDef<any>[] = [
        {
            id: 'line',
            header: 'Line',
            Cell: ({ row, table }) => {
                // control line stays the same
                if (row.original.type === 'control') {
                    return 'Control line';
                }

                // collect just the test rows
                const testRows = table
                    .getRowModel()
                    .rows.filter(r => r.original.type !== 'control');

                // find this row’s position among test rows
                const testIndex = testRows.findIndex(r => r.id === row.id);

                // invert: highest number at top, down to 1
                const total = testRows.length;
                const reversedNumber = total - testIndex;

                return `Test Line ${reversedNumber}`;
            },
        },
        {
            header: "Position",
            accessorKey: "peak_position",
        },
        {
            header: "Height",
            accessorKey: "score",
        },
        // {
        //     header: "Area",
        //     accessorKey: "area",
        // },
        {
            header: "T/C Height",
            accessorKey: "tc_height_ratio",
        },
        // {
        //     header: "T/C Area",
        //     accessorKey: "tc_area_ratio",
        // },
    ];

    // Build rows from your selectedStrip data
    const tableRows = selectedStrip?.lines?.map((line: any, index: number) => {
        // const TCAreaRatio = Number(line.area) / Number(result?.test_strips[selectedImageIndex]?.c_line?.area);

        return {
            type: 'test',
            index,
            peak_position: line.peak_position ? parseFloat(line.peak_position).toFixed(2) : '-',
            score: line.score ? parseFloat(line.score).toFixed(2) : '-',
            // area: line.area ? parseFloat(line.area).toFixed(2) : '-',
            tc_height_ratio: line.tc_ratio ? parseFloat(line.tc_ratio).toFixed(2) : '-',
            // tc_area_ratio: TCAreaRatio ? TCAreaRatio.toFixed(2) : '-',
        }
    });

    // Append the control line row with an index (e.g., using the length of test lines)
    tableRows.unshift({
        type: 'control',
        index: selectedStrip.lines.length, // or use -1 if you prefer
        peak_position: selectedStrip.c_line?.peak_position
            ? parseFloat(selectedStrip.c_line.peak_position).toFixed(2)
            : '-',
        score: selectedStrip.c_line?.score
            ? parseFloat(selectedStrip.c_line.score).toFixed(2)
            : '-',
        // area: selectedStrip.c_line?.area
        //     ? parseFloat(selectedStrip.c_line.area).toFixed(2)
        //     : '-',
        tc_height_ratio: '-', // not applicable for control line
        // tc_area_ratio: '-',        // not applicable for control line
    });


    return !result_id ? (
        <Navigate to={"/results"} />
    ) : !result ? (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ width: "100%" }}>
                <LinearProgress />
            </Box>
            {errors && (
                <Alert severity="error" style={{ width: "100%%" }}>
                    <AlertTitle>Error</AlertTitle>
                    {errors}
                </Alert>
            )}
        </Box>
    ) : (
        <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit} style={{}}>

                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 3,
                        p: 2,
                    }}
                >

                    {/* Section 1 – on large screens, this is in the middle; on md, it’s full width on top */}
                    <Box
                        sx={{
                            order: { xs: 1, md: 1, lg: 2 },
                            flex: { xs: '1 1 100%', md: '1 1 100%', lg: '1 1 610px' },
                        }}
                    >
                        <Card sx={{ p: 2, height: "100%" }}>
                            <Alert icon={false}
                                severity={
                                    formik.values.is_reviewed ? 'info' : formik.values.initial_visual_interpretation ? 'warning' : 'success'
                                }
                                sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                                <Box onClick={toggleViewVisualResult} sx={{ width: '100%', cursor: 'pointer', display: 'flex', gap: 1, alignItems: 'center', pb: 1 }}>


                                    {formik.values.is_reviewed ? (
                                        <>
                                            <CheckIcon fontSize="small" color="primary" />{' '}
                                            <AlertTitle sx={{ p: 0, m: 0, fontSize: '16px' }}>
                                                <strong>Reviewed:</strong> {formik.values.reviewed_timestamp}
                                            </AlertTitle>
                                        </>
                                    ) : formik.values.initial_visual_interpretation ? (
                                        <>
                                            <WarningAmberOutlinedIcon fontSize="small" color="warning" />{' '}
                                            <AlertTitle sx={{ p: 0, m: 0, fontSize: '16px' }}>
                                                <strong>Pending Review:</strong> App User Provided Interpretation
                                            </AlertTitle>
                                        </>
                                    ) : (
                                        <>
                                            <InfoOutlinedIcon fontSize="small" color="primary" />{' '}
                                            <AlertTitle sx={{ p: 0, m: 0, fontSize: '16px' }}>
                                                <strong>Pending Review</strong>
                                            </AlertTitle>
                                        </>
                                    )}

                                </Box>

                                {reviewingInterpretation ? (
                                    <Collapse in={reviewingInterpretation}>
                                        <Box sx={{ width: "100%", display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                            <Box sx={{ width: "100%", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <Box sx={{ width: "100%", px: 1, }}>
                                                    <Box sx={{ width: '100%' }}>
                                                        {formik.values.visual_result_notes && <Field name="visual_result_notes" type="text" className="form-control" label="Visual Interpretation Notes" rows={3} component={NotesBulkReviewEditField} />}
                                                    </Box>
                                                    <Box sx={{ width: '100%', display: "flex", justifyContent: 'center', alignItems: 'center', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 0.5, sm: "10px" } }}>
                                                        {formik.values.app_interpretation && <Field name="nothing" visualResult={formik.values.app_interpretation} type="text" className="form-control" label="Initial App Interpretation" component={FormVisualResultsBulkReviewField} />}
                                                        {formik.values.initial_visual_interpretation && (<> vs <Field name="nothing" visualResult={formik.values.initial_visual_interpretation} type="text" className="form-control" label="Users Visual Interpretation" component={FormVisualResultsBulkReviewField} /> </>)}
                                                    </Box>
                                                </Box>
                                                <Divider sx={{ my: 1.5, width: '90%' }} />
                                                <AlertTitle sx={{ alignSelf: 'flex-start' }}>Review</AlertTitle>
                                                <Box sx={{ px: 1, width: '100%', my: 1 }}>
                                                    <Box sx={{ pb: 1, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 4, sm: 4 } }}>
                                                        {!formik.values.initial_reviewer_interpretation ? (null) :
                                                            (
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                    <Typography>Reviewer's Visual Interpretation </Typography>
                                                                    <ResultClassLabel labelcolour={interpretationColours[formik.values.initial_reviewer_interpretation as keyof typeof interpretationColours]} value={formik.values.initial_reviewer_interpretation} />
                                                                </Box>
                                                            )
                                                        }
                                                    </Box>
                                                    {formik.values.is_reviewed && (
                                                        <Box sx={{ pb: 1, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 4, sm: 2 } }}>
                                                            <Field name="reviewer_id" type="text" className="form-control" label="Reviewer ID" component={ResultDetailEditField} />
                                                            <Field name="reviewed_timestamp" type="text" className="form-control" label="Review Date" component={ResultDetailEditField} />
                                                        </Box>
                                                    )}
                                                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 4, sm: 2 } }}>
                                                        <Field options={formik.values.is_reviewed ? ["Change"] : ["Agree", "Change"]} name="reviewer_agrees" type="text" className="form-control" label="Reviewer Action" component={InterpretationReviewSelectField} />
                                                        <Field name="reviewer_interpretation" type="text" className="form-control" label="Reviewer Visual Interpretation" component={InterpretationSelectField}
                                                            options={
                                                                formik.values.reviewer_agrees === 'Agree'
                                                                    ? [formik.values.final_result_interpretation as InterpretationOption]
                                                                    : (['POSITIVE', 'NEGATIVE', 'BORDERLINE', 'INVALID'] as const)
                                                            }
                                                        />
                                                    </Box>
                                                    <Field name="reviewer_notes" type="text" className="form-control" label="Add Reviewer Note" rows={3} component={NotesBulkReviewEditField} />
                                                </Box>
                                                <Tooltip title={!formik.values.reviewer_notes ? "Add a reviewer note" : ""}>
                                                    <Box sx={{ pt: 1, width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                                        <RareButton variant="outlined" onClick={closeReview}>Cancel</RareButton>
                                                        <RareButton disabled={loading || !formik.values.reviewer_agrees || (formik.values.reviewer_agrees === "Change" && !formik.values.reviewer_interpretation)} type='submit' variant="success" sx={{ display: 'flex', gap: 1 }}>
                                                            {formik.values.is_reviewed ? "Updated Review" : "Confirm Review"}
                                                            {loading && <CircularProgress sx={{ ml: 1, maxHeight: '14px', maxWidth: '14px' }} />}
                                                        </RareButton>
                                                    </Box>
                                                </Tooltip>
                                            </Box>
                                        </Box>
                                    </Collapse>
                                ) : (
                                    <Box sx={{ width: "100%", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        {formik.values.is_reviewed ? "Visual Inerpretation has been reviewed successfully" : formik.values.initial_visual_interpretation ? "The App User has provided a Visual Interpretation that requires review" : "Action Required"}
                                        <RareButton onClick={openReview} variant="contained" sx={{ ml: 2 }}>
                                            Review
                                        </RareButton>
                                    </Box>
                                )}

                            </Alert>
                            {/* )} */}
                            {/* </Box> */}
                            {/* )} */}

                            <Box sx={{ width: '100%', display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                <Box sx={{ width: '100%', display: "flex", flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 0.5, sm: "50px" } }}>
                                    {formik.values.final_result_interpretation && <Field name="nothing" visualResult={formik.values.final_result_interpretation} type="text" className="form-control" label="Interpretation" component={FormVisualResultsField} />}
                                    {testImage && (
                                        <Box sx={{ minWidth: '50%' }} onClick={() => handleImageOpen(testImage)} >
                                            <Field name="nothing" image={testImage} type="text" className="form-control" label="Test image" component={ImageField} />
                                        </Box>
                                    )}
                                </Box>
                                <Box sx={{ width: { xs: '100%', sm: '80%', md: '80%', lg: '80%' }, pb: 2, pt: 1, height: '100%', display: 'flex', justifyContent: 'center', maxWidth: "700px", }}>
                                    <ResultDetailGraph graphdata={graphData} showGraph={true} />
                                </Box>
                            </Box>

                            {formik.values.type === "ABORTED" ? ( // If the result is aborted
                                <Box sx={{ pt: 2, }}>
                                    <Alert severity="warning" style={{ width: "100%" }}>
                                        <AlertTitle>This test was Aborted</AlertTitle>
                                        Reason: {formik.values.aborted_reason}
                                    </Alert>
                                </Box>
                            ) : (

                                <ResultDetailTable rows={tableRows} isLoading={false} columns={detailColumns} />
                            )}
                        </Card>
                    </Box>

                    {/* Section 2 – on lg: first in the row; on md: second row (left); on xs/sm: full width */}
                    <Box
                        sx={{
                            order: { xs: 2, md: 2, lg: 1 },
                            flex: {
                                xs: '1 1 100%',
                                md: '1 1 calc(50% - 1.5rem)', // 50% each minus half the gap
                                lg: '0 1 366px',
                            },
                        }}
                    >
                        <Card sx={{ p: 2, height: "100%" }}>
                            <div className="form-group">
                                <Field name="timestamp" type="text" className="form-control" label="Created At" component={ResultDetailEditField} />
                                <Field name="id" type="text" className="form-control" label="Result ID" component={ResultDetailEditField} />
                                <Field name="user_email" status={formik.values.user_is_active} id={formik.values.result_user_id} type="text" className="form-control" label="Created By" component={UserTextAdornmentReadOnlyField} />
                                <Field name="organisation_name" id={formik.values.organisation_id} type="text" className="form-control" label="Organisation" component={OrganisationTextAdornmentReadOnlyField} />
                                <Field name="lot_number" id={formik.values.batch_id} type="text" className="form-control" label="Lot / Batch" component={BatchTextAdornmentReadOnlyField} />
                                <Field name="sample_id" type="text" className="form-control" label="Sample ID" component={ResultDetailEditField} />
                                <Field name="sample_type" type="text" className="form-control" label="Sample Type" component={ResultDetailEditField} />
                                <Field name="test_type" type="text" className="form-control" label="Test Type" component={ResultDetailEditField} />
                            </div>
                        </Card>
                    </Box>


                    {/* Section 3 – on lg: third in the row; on md: second row (right); on xs/sm: full width */}
                    <Box
                        sx={{
                            order: { xs: 3, md: 2, lg: 3 },
                            flex: {
                                xs: '1 1 100%',
                                md: '1 1 calc(50% - 1.5rem)',
                                lg: '0 1 366px',
                            },
                        }}
                    >
                        <Card sx={{ p: 2, height: "100%" }}>

                            <div className="form-group">
                                <Field name="notes" type="text" className="form-control" label="Notes" rows={3} component={NotesField} />
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Field name="app_version" type="text" className="form-control" label="App Version" component={ResultDetailEditField} />
                                    <Field name="app_build" type="text" className="form-control" label="App Build" component={ResultDetailEditField} />
                                </Box>
                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Field name="device_model" type="text" className="form-control" label="Device Model" component={ResultDetailEditField} />
                                    <Field name="os_version" type="text" className="form-control" label="OS Version" component={ResultDetailEditField} />
                                </Box>
                                {stripImages.map((image, index) => {
                                    const title = `Test strip image ${index + 1}:`
                                    return (
                                        <Box onClick={() => handleImageOpen(image)} >
                                            <Field key={index} name="nothing" image={image} type="text" className="form-control" label={title} component={StripImageField} />
                                        </Box>
                                    )
                                })}
                            </div>
                        </Card>
                    </Box>
                </Box>
                {/* Section 4 – back button */}
                <Box
                    sx={{
                        width: '100%',
                        ml: 1
                    }}
                >
                    <RareButton
                        onClick={() => handleBackButton()}
                        variant="outlined"
                        sx={{
                            position: "relative",
                            m: 1,
                        }}
                    >
                        Back
                    </RareButton>
                </Box>

                {/* Dialog for Frame Image Popup */}
                <Dialog data-testid="Dialog-njls"
                    open={openImagePopup}
                    onClose={handleImageClose}
                    maxWidth="md"
                    fullWidth
                    slotProps={{ backdrop: { onClick: handleImageClose } }} // Close on clicking outside
                >
                    <DialogContent data-testid="DialogContent-o77v" sx={{ padding: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box data-testid="Box-3rd9"
                            onClick={handleImageClose}
                            component="img"
                            src={selectedImage}
                            alt="Frame Image"
                            sx={{ width: '100%', height: 'auto', objectFit: 'contain', cursor: 'pointer' }}
                        />
                    </DialogContent>
                </Dialog>
            </form >
        </FormikProvider >
    )
}

export default ResultDetailCard;